import { LS_BRANCHID } from "@/shared/constants";
import IconButton from "@mui/material/IconButton";
import { type GridColDef } from "@mui/x-data-grid";
import { get } from "lodash-es";
import {
  TbChevronDown,
  TbChevronUp,
  TbEye,
  TbPencil,
  TbTrash,
} from "react-icons/tb";
import Tooltip from "@mui/material/Tooltip";
import { Cancel } from "@mui/icons-material";

const branchId = localStorage.getItem(LS_BRANCHID);

export const getTableColumns = <TData extends { _id: string }>({
  numerate,
  columns,
  onEditColumn,
  onDeleteColumn,
  onCancelColumn,
  isCancelColumnVisible,
  onSeenClick,
  deleteTitle,
  updateTitle,
  additionalActions = [],
  archiveIcon,
  unArchiveIcon,
  cancelTitle,
  t,
}: {
  numerate?: boolean;
  columns: GridColDef<any>[];
  onEditColumn?: (props?: any) => void;
  onDeleteColumn?: (props?: any) => void;
  onSeenClick?: (props?: any) => void;
  deleteTitle: string;
  updateTitle: string;
  additionalActions?: any;
  archiveIcon?: boolean;
  unArchiveIcon?: boolean;
  t: (key: string) => string;
  cancelTitle: string;
  onCancelColumn?: (props?: any) => void;
  isCancelColumnVisible?: (row: TData) => boolean;
}): GridColDef<any>[] =>
  [
    numerate
      ? {
        field: "_number",
        headerName: "№",
        maxWidth: 60,
        minWidth: 60,
        align: "center",
        // sortable: true,
        filterable: false,
        headerAlign: "center",
        disableColumnMenu: true,
      }
      : undefined,
    ...columns,
    typeof onSeenClick === "function"
      ? {
        field: t("TABLE.SEE"),
        renderCell(row: any) {
          return (
            <div className="flex items-center justify-center h-full">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  onSeenClick(row.row);
                }}
              >
                <TbEye />
              </IconButton>
            </div>
          );
        },
        maxWidth: 60,
        align: "center",
        headerAlign: "center",
        renderHeader: () => null,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      }
      : undefined,
    ...additionalActions,
    typeof onEditColumn === "function"
      ? {
        field: t("TABLE.EDIT"),
        renderCell(row: any) {
          return (
            <div className="flex items-center justify-center h-full">
              <Tooltip title={updateTitle}>
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    onEditColumn(row.row);
                  }}
                >
                  <TbPencil />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
        maxWidth: 60,
        align: "center",
        headerAlign: "center",
        renderHeader: () => null,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      }
      : undefined,
    typeof onCancelColumn === "function"
      ? {
        field: cancelTitle,
        renderCell(row: any) {
          if (
            typeof isCancelColumnVisible === "function" &&
            !isCancelColumnVisible(row?.row)
          ) {
            return null;
          }
          return (
            <div className="flex items-center justify-center h-full">
              <Tooltip title={cancelTitle}>
                <IconButton
                  color="warning"
                  onClick={(e) => {
                    e.stopPropagation();
                    onCancelColumn(row.row);
                  }}
                >
                  <Cancel />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
        maxWidth: 60,
        align: "center",
        headerAlign: "center",
        renderHeader: () => null,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      }
      : undefined,

    typeof onDeleteColumn === "function"
      ? {
        field: t("TABLE.DELETE"),
        renderCell(row: any) {
          return (
            get(row, "row._id", "") !== branchId && (
              <div className="flex items-center justify-center h-full">
                <Tooltip title={deleteTitle}>
                  <IconButton
                    color="error"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteColumn(row.row);
                    }}
                  >
                    <>
                      {archiveIcon ? (
                        <TbChevronUp className={"text-red-500"} />
                      ) : unArchiveIcon ? (
                        <TbChevronDown className={"text-red-500"} />
                      ) : (
                        <TbTrash />
                      )}
                    </>
                  </IconButton>
                </Tooltip>
              </div>
            )
          );
        },
        maxWidth: 60,
        align: "center",
        headerAlign: "center",
        renderHeader: () => null,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      }
      : undefined,
  ]
    .filter(Boolean) // get rid of undefined values
    .map((item, index) => ({
      disableColumnMenu: true,
      sortable: false,
      headerClassName: "table-header",
      flex: item?.flex ? item.flex : 1,
      minWidth: index === 0 ? 60 : 80,
      ...item,
    }));
